module.exports = __webpack_public_path__ + "img/BigLoader.fee909ba.png";